/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_OverwriteInputs */

const cs_property_ai_overwrite = /** @type {(inputs: Property_Ai_OverwriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přepsat existující překlady`)
};

const en_property_ai_overwrite = /** @type {(inputs: Property_Ai_OverwriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overwrite existing translations`)
};

/**
* | output |
* | --- |
* | "Overwrite existing translations" |
*
* @param {Property_Ai_OverwriteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_overwrite = /** @type {((inputs?: Property_Ai_OverwriteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_OverwriteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_overwrite(inputs)
	return cs_property_ai_overwrite(inputs)
});